import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

//MARCAS
export const getMarcas = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/Marcas', 'GET');
  return response;
}

export const guardarMarca = async (Datos) =>{
  const response = await PrivateInterceptor('Admin/Dispositivos/Agregar', 'POST', {Datos});
  return response;
}

export const editarMarca = async (Datos) =>{
  const response = await PrivateInterceptor('Admin/Dispositivos/Editar', 'POST', {Datos});
  return response;
}

//Tipo Dispositivos
export const getTipoDispositivos = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/TipoDispositivos', 'GET');
  return response;
}

export const guardarTipoDispositivo = async (Datos) =>{
  const response = await PrivateInterceptor('Admin/Dispositivos/AgregarTD', 'POST', {Datos});
  return response;
}

export const editarTipoDispositivo = async (Datos) =>{
  const response = await PrivateInterceptor('Admin/Dispositivos/EditarTD', 'POST', {Datos});
  return response;
}

//Routers
export const getRouters = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/Routers', 'GET');
  return response;
}

export const guardarRouter = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/AgregarRouter", "POST", {datos});
  return respuesta;
};

export const editarRouter = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/EditarRouter", "POST", {datos});
  return respuesta;
};

export const chageEstadoRouters = async (data) => {
  const result = await PrivateInterceptor(`Admin/Dispositivos/chageEstadoRouter`, 'POST', data);
  return result;
}

//Redes
export const getRedes = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/Redes', 'GET');
  return response;
};

export const chageEstadoRedes = async (data) => {
  const result = await PrivateInterceptor(`Admin/Dispositivos/chageEstadoRed`, 'POST', data);
  return result;
}

export const getTipoRed = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/TipoRed', 'GET');
  return response;
}

export const getClaseRed = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/ClaseRed', 'GET');
  return response;
}

export const guardarRed = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/AgregarRed", "POST", {datos});
  return respuesta;
};

export const editarRed = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/EditarRed", "POST", {datos});
  return respuesta;
};

//Red Video
export const getRedVideo = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/RedVideo', 'GET');
  return response;
};

export const chageEstadoRedVideo = async (data) => {
  const result = await PrivateInterceptor(`Admin/Dispositivos/chageEstadoRedVideo`, 'POST', data);
  return result;
};

export const guardarRedVideo = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/AgregarRedVideo", "POST", {datos});
  return respuesta;
};

export const editarRedVideo = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/EditarRedVideo", "POST", {datos});
  return respuesta;
};

//Red Telefonia
export const getRedTelefonia = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/RedTelefonia', 'GET');
  return response;
};

export const chageEstadoRedTelefonia = async (data) => {
  const result = await PrivateInterceptor(`Admin/Dispositivos/chageEstadoRedTelefonia`, 'POST', data);
  return result;
};

export const guardarRedTelefonia = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/AgregarRedTelefonia", "POST", {datos});
  return respuesta;
};

export const editarRedTelefonia = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/EditarRedTelefonia", "POST", {datos});
  return respuesta;
};

//Extensiones Telefonicas
export const getExtensiones = async () => {
  const response = await PrivateInterceptor('Admin/Dispositivos/getExtensiones', 'GET');
  return response;
};

export const chageEstadoExtensiones = async (data) => {
  const result = await PrivateInterceptor(`Admin/Dispositivos/chageEstadoExtensiones`, 'POST', data);
  return result;
};

export const guardarExtension = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/guardarExtension", "POST", {datos});
  return respuesta;
};

export const editarExtension = (datos) => {
  const respuesta = PrivateInterceptor("Admin/Dispositivos/editarExtension", "POST", {datos});
  return respuesta;
};